/**
 * gift-handler.js — Minki Beauty regalo sorpresa
 *
 * Auto-añade el producto wrapper "🎁 Regalo sorpresa Minki Beauty"
 * cuando el subtotal del carrito (sin contar el regalo) llega a 65€,
 * y lo retira si baja de ese umbral.
 *
 * Decisión de subtotal: usa items_subtotal_price (pre-descuento) — el cliente
 * percibe coherencia ("metí 65€ de productos, tengo regalo"), aunque luego
 * un código de descuento baje el carrito por debajo.
 */
(function () {
  'use strict';

  var GIFT_VARIANT_ID = 55774326063489;
  var THRESHOLD_CENTS = 6500; // 30-sep-2026: umbral 95 → 65 € (decisión de Minki)
  var processing = false;

  function findGiftLine(cart) {
    return (cart.items || []).find(function (item) {
      return item.variant_id === GIFT_VARIANT_ID;
    });
  }

  function eligibleSubtotal(cart) {
    var giftLine = findGiftLine(cart);
    var giftSubtotal = giftLine ? giftLine.original_line_price : 0;
    var subtotal = (cart.items_subtotal_price != null)
      ? cart.items_subtotal_price
      : (cart.original_total_price != null ? cart.original_total_price : cart.total_price);
    return subtotal - giftSubtotal;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('cart fetch failed');
      return r.json();
    });
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity: 1,
        properties: { '_gift': 'true' }
      })
    });
  }

  function removeGift(itemKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    });
  }

  function normalizeGiftQuantity(itemKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 1 })
    });
  }

  function notifyCartUpdate() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-handler' });
      } catch (_) {}
    }
  }

  function reconcile() {
    if (processing) return Promise.resolve();
    processing = true;
    return fetchCart()
      .then(function (cart) {
        if (!cart || cart.item_count === 0) return null;
        var giftLine = findGiftLine(cart);
        var subtotal = eligibleSubtotal(cart);
        // Normalizar: el regalo siempre debe ser 1 unidad como máximo.
        // Una race condition con varios cart/add.js casi simultáneos podría incrementar la línea.
        if (giftLine && giftLine.quantity > 1) {
          return normalizeGiftQuantity(giftLine.key).then(notifyCartUpdate);
        }
        if (subtotal >= THRESHOLD_CENTS && !giftLine) {
          return addGift().then(notifyCartUpdate);
        }
        if (subtotal < THRESHOLD_CENTS && giftLine) {
          return removeGift(giftLine.key).then(notifyCartUpdate);
        }
        return null;
      })
      .catch(function (err) {
        console.error('[gift-handler]', err);
      })
      .then(function () {
        processing = false;
      });
  }

  function reorderGiftRows() {
    var tables = document.querySelectorAll('.cart-items');
    for (var i = 0; i < tables.length; i++) {
      var tbody = tables[i].querySelector('tbody');
      if (!tbody) continue;
      var giftRows = tbody.querySelectorAll('tr.cart-item--gift');
      for (var j = 0; j < giftRows.length; j++) {
        tbody.appendChild(giftRows[j]);
      }
    }
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        // Reordenar siempre tras un cart update (Dawn re-renderiza el drawer).
        // Damos un microtick para que el DOM esté actualizado.
        setTimeout(reorderGiftRows, 0);
        if (event && event.source === 'gift-handler') return;
        reconcile();
      });
    }
    reorderGiftRows();
    reconcile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
